import { useField } from "@unform/core";
import { forwardRef, useEffect, useRef, useState } from "react";

import UseNotification from "Hooks/UseNotification";

import GetIcon from "Components/Global/Icons";

import Affix from "../../Components/Affix";
import HelpText from "../../Components/HelpText";
import * as S from "./styles";

import { useTheme } from "styled-components";

// eslint-disable-next-line react/display-name
export const File = forwardRef(
  (
    {
      allowMultiple,
      gridArea,
      margin,
      error,
      allowedExtensions,
      disabled,
      maxWidth,
      ...props
    },
    ref,
  ) => {
    const { showNotification } = UseNotification();
    const theme = useTheme();

    const [value, setValue] = useState(props?.defaultValue);
    const inputRef = useRef(null);
    const { fieldName, registerField } = useField(props?.name);
    const [state, setState] = useState();

    useEffect(() => {
      if (props?.mask) {
        registerField({
          name: fieldName,
          ref: ref ? ref.current : inputRef.current,
          path: "value",
          setValue(ref, value) {
            setValue(value);
          },
          clearValue() {
            setValue("");
          },
          getValue() {
            return value;
          },
        });
      } else {
        registerField({
          name: fieldName,
          ref: ref ? ref.current : inputRef.current,
          path: "value",
        });
      }
    }, [fieldName, registerField, value, props.mask, ref]);

    useEffect(() => {
      if (props?.value) {
        setValue(props.value);
      }
    }, [props?.value]);

    const handleChange = (file) => {
      if (!file) return;

      if (
        allowedExtensions &&
        !allowedExtensions.includes(file.name.split(".").pop().toLowerCase())
      ) {
        return showNotification(
          "danger",
          "Atenção",
          "Selecione um arquivo válido.",
        );
      }

      if (file.size > 30000000) {
        return showNotification(
          "danger",
          "Atenção",
          "O arquivo deve conter no máximo 30 MB.",
        );
      }

      props.onChange(allowMultiple ? [...props.value, file] : file);
    };

    return (
      <S.Wrapper
        key="wrapper"
        gridArea={gridArea}
        margin={margin}
        onClick={(e) => {
          if (e.target.tagName === "svg" || e.target.tagName === "path") return;
          e.stopPropagation();

          !disabled && inputRef.current.click();
        }}
        disabled={disabled}
        maxWidth={maxWidth}
      >
        {props?.label && (
          <S.Label htmlFor={fieldName} size={props?.size}>
            {props?.label} {props?.required && <S.RequiredDot />}
          </S.Label>
        )}
        <S.InputWrapper state={state} disabled={disabled}>
          {props.value &&
          (Array.isArray(props.value) ? props.value.length : true) ? (
            <S.Files>
              {(Array.isArray(props.value) ? props.value : [props.value]).map(
                (file) => {
                  const file_name = file?.file_name
                    ? file?.file_name
                    : file?.name
                      ? file?.name
                      : "Arquivo enviado";

                  return (
                    <S.File key={file.name}>
                      <span>
                        {file_name.length > 20
                          ? `${file_name.substring(0, 20)}...`
                          : file_name}
                      </span>
                      <GetIcon
                        name="X"
                        size="xs"
                        color={theme.colors.neutral.black}
                        onClick={() =>
                          !disabled &&
                          props.onChange(
                            allowMultiple
                              ? props.value.filter((f) =>
                                  file?.file_name
                                    ? f.file_name !== file?.file_name
                                    : f.name !== file.name,
                                )
                              : null,
                          )
                        }
                      />
                    </S.File>
                  );
                },
              )}
            </S.Files>
          ) : (
            <S.FileName state={state}>
              <span>{props.placeholder}</span>
            </S.FileName>
          )}
          <Affix
            suffix="true"
            icon={{
              name: "Upload",
              position: "right",
              size: "xs",
              color: theme.colors.neutral.black,
            }}
            size={props?.size}
            disabled={props.disabled}
            isFile
          />
        </S.InputWrapper>
        {error && (
          <HelpText
            id={fieldName}
            text={error}
            size={props?.size}
            setState={setState}
          />
        )}

        <S.HiddenInput
          ref={inputRef}
          type="file"
          onChange={(e) => !disabled && handleChange(e.target.files[0])}
        />
      </S.Wrapper>
    );
  },
);
